import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import config from "./configs/config";
import { RouterLink } from "vue-router";
// import { useStore } from './store/index'
import { createPinia } from "pinia";
// import { createHead } from '@unhead/vue'
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createMetaManager, defaultConfig } from "vue-meta";

//plugin and configs
import MyPlugin from "./plugins/plugin";
import languages from "./configs/language";
import axios from "axios";

// import 'primevue/resources/themes/lara-light-teal/theme.css'
import "primeicons/primeicons.css";
import "/node_modules/primeflex/primeflex.css";
import Tooltip from "primevue/tooltip";

import { useUserStore } from "./stores/UserStore";
import { useGeneralStore } from "./stores/GeneralStore";

//google maps
import VueGoogleMaps from "@fawmi/vue-google-maps";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas, far, fab);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
// const head = createHead();

let userStore = null;
let generalStore = null;
router.beforeEach((to) => {
  userStore = useUserStore();
  generalStore = useGeneralStore();

  // Jangan redirect ke login jika rute adalah /privacy_policy dan track n trace
  if (to.path === "/privacy_policy" || to.path === "/privacy_policy_forsis" || to.name === "TrackTrace" || to.name === "TrackOrder") {
    return true;
  }

  // Redirect ke login jika user belum login
  if (to.path != "/" && userStore.user_id == null) {
    return { path: "/" };
  } else if (to.path == "/" && userStore.user_id) {
    return { path: "/admin" };
  } else {
    generalStore.activeMenu = to.name;
    generalStore.activeGroupMenu = to.fullPath;
  }
});

const metaManager = createMetaManager(false, {
  ...defaultConfig,
  meta: { tag: "meta", nameless: true },
});

let gmapsKey = config.activeOwner == 1 ? config.owner[0].gmapsKey : config.owner[1].gmapsKey;

const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(metaManager)
  .use(PrimeVue)
  .use(ToastService)
  .use(ConfirmationService)
  .use(VueGoogleMaps, {
    load: {
      key: gmapsKey,
      libraries: "places",
    },
  });

app.component("router-link", RouterLink);
app.component("font-awesome-icon", FontAwesomeIcon);
// .use(head)

app.directive("tooltip", Tooltip);

// let store = useStore();
//register the plugins
app.config.globalProperties.axios = axios;
app.config.globalProperties.myPlugin = MyPlugin;
app.config.globalProperties.languages = languages;
// app.config.globalProperties.store = store;

app.mount("#app");
